import { render, staticRenderFns } from "./EnrollmentToggle.vue?vue&type=template&id=74095265&scoped=true&"
import script from "./EnrollmentToggle.vue?vue&type=script&lang=js&"
export * from "./EnrollmentToggle.vue?vue&type=script&lang=js&"
import style0 from "./EnrollmentToggle.vue?vue&type=style&index=0&id=74095265&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74095265",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
installComponents(component, {VBtn,VBtnToggle})
